import React from "react";

import { BoxAuditReportManuallyButton } from "./BoxAuditReportManuallyButton";
import { UnexpectedSkuModal } from "../components/modals";

export const BoxAuditUnexpectedSkuModal = () => (
  <UnexpectedSkuModal ReportManuallyButton={BoxAuditReportManuallyButton} />
);
